<template>
  <div id="play-navigation" class="play-navigation">
    <h2 class="page-heading">Play Navigation</h2>
    <ul>
      <li v-for="board in boards" :key="board.boardId" :class="boardModeModifierClass(board.mode)">
        {{ board.name }} : {{ board.boardId }}
        <router-link
          :to="{
            name: 'play',
            params: {boardIdOrSlug: board.slug},
          }"
          >Play</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import db from './../firebaseInit';
import {BOARD_MODES} from './../constants/globalConstants';

const userVuexModule = createNamespacedHelpers('userVuexModule');

export default {
  name: 'play-navigation',
  title: 'Play',
  data() {
    return {
      boards: [],
    };
  },
  created() {
    db.collection('boards')
      .orderBy('name')
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          const data = {
            boardCreatedAt: doc.data().boardCreatedAt,
            boardId: doc.data().boardId,
            mode: doc.data().mode,
            imagesFolderName: doc.data().imagesFolderName,
            name: doc.data().name,
            promoted: doc.data().promoted,
          };
          this.boards.push(data);
        });
      });
  },
  methods: {
    boardModeModifierClass: function(boardMode) {
      switch (boardMode) {
        case BOARD_MODES.LIVE.CONSTANT:
          return 'board-listing--live';
        case BOARD_MODES.TESTING.CONSTANT:
          return 'board-listing--testing';
        case BOARD_MODES.DISABLED.CONSTANT:
          return 'board-listing--disabled';
        default:
          return '';
      }
    },
  },
  computed: {
    ...userVuexModule.mapGetters(['userCanRead', 'userCanEdit', 'userCanCreate', 'userCanDelete']),
  },
};
</script>

<style lang="scss" scoped></style>
